import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { CommonButtonRowWidget, UtilityService } from "@eforall/common";
import { DialogService, GridContentWidget } from "@eforall/dashboard";
import { AppService, DomainDataService } from "../../../../services";
import { AccApplicationDialogDataService } from "../acc-application-dialog-data.service";
import { getSetup } from "./grid/get-setup";

@Component({
	selector: 'acc-application-contact-dialog-part',
	standalone: true,
	imports: [
		CommonButtonRowWidget,
		GridContentWidget
	],
	templateUrl: './acc-application-contact-dialog.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './acc-application-contact-dialog.part.scss'
})
export class AccApplicationContactDialogPart {

	public dialogBodyHeight = input.required<number>();

	private accApplDialogDataService = inject(AccApplicationDialogDataService);
	private util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	private readonly domainDataService = inject(DomainDataService);
	private readonly app = inject(AppService);

	public setup = getSetup(this.accApplDialogDataService, this.util, this.dialog, this.app);

	// subtracting (70 + 165) to account for padding, tabstrip and applicant contact details, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 235 - (this.accApplDialogDataService.isReadonly() ? 45 : 0));

	public contactRequests = computed(() => this.accApplDialogDataService.dialogData()?.contactEngagements ?? []);
	private readonly participants = computed(() => {
		const accApplication = this.accApplDialogDataService.dialogData()?.details;
		if (!accApplication) return [];
		return [accApplication.participant?.personId, ...(accApplication.coParticipants?.map((v) => v.personId) || [])];
	})
	public readonly participant = computed(() => {
		const accApplication = this.accApplDialogDataService.dialogData()?.details;
		return {
			...accApplication?.participant,
			contactMethod: accApplication?.participant?.contactMethodId && this.domainDataService.data().contactMethodMap[accApplication?.participant?.contactMethodId]?.name,
		};
	})

	public readonly coParticipants = computed(() => {
		const accApplication = this.accApplDialogDataService.dialogData()?.details;
		return accApplication?.coParticipants.map(cp => ({
			...cp,
			contactMethod: cp.contactMethodId && this.domainDataService.data().contactMethodMap[cp.contactMethodId]?.name,
		}));
	})

	sendEmail(email: string) {
		this.util.send.sendEmail(email);
	}

	sendText(phone: string) {
		this.util.send.sendText(phone);
	}

	openPhone(phone: string) {
		this.util.send.openPhone(phone);
	}
}